import {
  useMutation,
  type MutationHookOptions,
  type MutationTuple,
  type TypedDocumentNode,
} from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RenameShowDocument, UpdateShowDocument } from './update.generated';

const useUpdate = <T, U>(
  document: TypedDocumentNode<T, U>,
  options: MutationHookOptions<T, U>,
): MutationTuple<T, U> => {
  const { t } = useTranslation();

  return useMutation(document, {
    ...useNotifications(document, {
      failure: t('api.common.error_generic'),
      success: t('api.shows.update_success'),
    }),
    ...options,
  });
};

export const useUpdateShow = (options: ApiOptions<typeof UpdateShowDocument> = {}) =>
  useUpdate(UpdateShowDocument, options);

export const useRenameShow = (options: ApiOptions<typeof RenameShowDocument> = {}) =>
  useUpdate(RenameShowDocument, options);
